import { render, staticRenderFns } from "./StackedVerticalBarCharts.vue?vue&type=template&id=33096be0&"
import script from "./StackedVerticalBarCharts.vue?vue&type=script&lang=js&"
export * from "./StackedVerticalBarCharts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports